import KendoGantt from '../KendoGantt'
import KendoGanttColumn from '../KendoGanttColumn'
import KendoGanttView from '../KendoGanttView'
import KendoGanttToolbar from '../KendoGanttToolbar'

let KendoGanttInstaller = class {
    static install(Vue) {
        Vue.component(KendoGantt.name, KendoGantt)
        Vue.component(KendoGanttColumn.name, KendoGanttColumn)
        Vue.component(KendoGanttView.name, KendoGanttView)
        Vue.component(KendoGanttToolbar.name, KendoGanttToolbar)
    }
}

export default KendoGanttInstaller

// Automatic installation if Vue has been added to the global scope.
if (typeof window !== 'undefined' && window.Vue && window.Vue.use) {
    window.Vue.use(KendoGanttInstaller)
}


// WEBPACK FOOTER //
// ./packages/kendo-gantt-vue-wrapper/src/kendo-gantt-installer/index.js